module.exports = __webpack_public_path__ + "img/app.dc716cc3.jpeg";